import { render, staticRenderFns } from "./BillingType.vue?vue&type=template&id=25780535&"
import script from "./BillingType.vue?vue&type=script&lang=js&"
export * from "./BillingType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports